import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import styled, { css } from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import { selectDevice, checkIfMDNisSMSCapable } from "../actions";
import { checkNestedObject } from "utils/checkNestedObject";
import { formatPhoneNumber } from "utils/formatPhoneNumber";
import { setA11yContent } from "../../NavigationHelper/actions";
import { media } from "utils/style";
// import { Line } from "@vds/lines";
// import DeviceMdn from "../../../../../assets/svgs/DeviceMdn.svg";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import Alert from "common-components/Alert";
import CommonHeader from "common-components/Header";
import CommonContainer from "common-components/Container";
import Button from "common-components/Buttons";
import { ListGroup,ListGroupItemImage, ListGroupItem, ListGroupItemTitle, ListGroupItemSubtitle } from "@vds/lists";
import { ButtonMDNDevice } from "common-components/Buttons";

class DeviceSelection extends Component {

  state = {
    selectedMDN: ""
  }
  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("Device selection", this.props.pageContent.sc_pagetitle);
    }
  }

  handleDeviceSelectionSubmit = () => {
    this.props.checkIfMDNisSMSCapable(this.state.selectedMDN).then(() => {
      if (!this.props.error) {
        const { mfaAllowed } = this.props.verifiedSecurePinDevice;

        if (mfaAllowed === false) {
          this.props.history.push("action-needed");
        } else {
          this.props.history.push({
            pathname: "/privacy/secure/multifactor-authentication-primer",
            state: { ...this.props.location.state }
          });
        }
      }
    });
  };

  render() {
    const { pageContent, loading } = this.props;

    if (!pageContent) {
      return <Redirect to="/privacy/secure/your-data" />;
    }

    if (loading) {
      return <RectangleLoader />;
    }
    return (
      <Container>
        <Header>{pageContent.section_title}</Header>
        <Div>{convertStringToElements(pageContent.section_description)}</Div>
        <Div style={{ marginTop: "30px" }}>
          {this.props.deviceList.map(
            (device, i) =>
              device.isMtnDisconnected === "false" && (
                <div key={device.mtn} style={{ marginBottom: "25px" }}>
                <ListGroup
                  topLine={false}
                  bottomLine={this.props.deviceList && i !== this.props.deviceList.filter(item => item.isMtnDisconnected === "false").length ? true : false}
                  surface="light"
                  viewport=""
                  >
                  <ListGroupItem actionElement="icon" onClick={() => {
                                    this.props.selectDevice(device)
                                    this.setState({
                                      selectedMDN: device.encryptedMtn
                                    }, () => {
                                      this.handleDeviceSelectionSubmit()
                                    })

                            }} ariaLabel={device.displayName+device.mtn}>
                          {device && device.imgUrl  ?
                          <ListGroupItemImage
                              size="82"
                              src={device.imgUrl}
                            />
                          :
                          <ListGroupItemImage
                              size="82"
                              src="https://www.verizon.com/image-files/reactVPD/vpd-assets/static/media/DeviceMdn.b93b6ce0.svg"
                            />                     
                      }
                  { device && device.displayName ?
                    <ListGroupItemTitle  bold={false}>
                      <span data-qm-encrypt="true">{convertStringToElements(device.displayName)}</span>
                    </ListGroupItemTitle>
                    : 
                    <ListGroupItemTitle bold={false}>
                      {convertStringToElements("")}
                    </ListGroupItemTitle>
                  }
                  <ListGroupItemSubtitle>
                  <HiddenSpan>Phone number: </HiddenSpan> <span data-qm-encrypt="true">{formatPhoneNumber(device.mtn)}</span>
                  </ListGroupItemSubtitle>
                </ListGroupItem>
                </ListGroup>                  
               </div>
              )
          )}
        </Div>

        {/* <fieldset role="radiogroup">
          <Legend>Select a device</Legend> 
         <DeviceListContainer>
            {this.props.deviceList.map(
              device =>
                device.isMtnDisconnected === "false" && (
                  <DeviceContainer key={device.mtn} checked={device.mtn === this.props.selectedDevice.mtn}>
                    {device.mtn === this.props.selectedDevice.mtn ? <Line /> : null}
                    <input
                      type="radio"
                      name="selectedDevice"
                      id={device.encryptedMtn}
                      checked={device.mtn === this.props.selectedDevice.mtn}
                      onChange={() => this.props.selectDevice(device)}
                    />
                    <label htmlFor={device.encryptedMtn}>
                      <span className="device_selection_span">
                        <Span style={{ display: "block" }}>{convertStringToElements(device.displayName)}</Span>
                        <Span>
                          <HiddenSpan>Phone number: </HiddenSpan> {formatPhoneNumber(device.mtn)}
                        </Span>
                      </span>
                    </label>

                    <img src={device.imgUrl} alt={device.productName} />
                  </DeviceContainer>
                )
            )}
          </DeviceListContainer>
        </fieldset>  */}

        {/* <Button
          disabled={!this.props.selectedDevice.mtn}
          onClick={this.handleDeviceSelectionSubmit}
          background={pageContent.buttons[0].type}
        >
          {pageContent.buttons[0].text}
        </Button> */}
        {this.props.error ? <Alert alertType="error">{this.props.error}</Alert> : null}
      </Container>
    );
  }
}

const mapStateToProps = ({
  pageContent,
  profileInformation,
  loadingAndErrorState,
  selectedDevice,
  verifiedSecurePinDevice
}) => ({
  pageContent: pageContent.device_selection,
  loading: loadingAndErrorState.loading,
  error: loadingAndErrorState.error,
  deviceList: profileInformation,
  selectedDevice: selectedDevice,
  verifiedSecurePinDevice
});

export default connect(
  mapStateToProps,
  { selectDevice, checkIfMDNisSMSCapable, setA11yContent }
)(DeviceSelection);

const screenReaderOnly = css`
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
`;

const HiddenSpan = styled.span`
  ${screenReaderOnly}
`;

const Legend = styled.legend`
  ${screenReaderOnly}
`;


const commonBorderStyle = css`
  border-right: 1px solid rgb(216, 218, 218) !important;
  border-left: 1px solid rgb(216, 218, 218) !important;

  :not(:first-child) {
    border-top: 0 !important;
  }
`;

const DeviceContainer = styled.li`
  flex: 50%;
  display: flex;
  border: 1px solid rgb(216, 218, 218);
  cursor: pointer;
  position: relative;
  max-width: 382px;
  min-height: 288px;
  width: 100%;
  font-size: 1.7rem;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;
  line-height: 28px;

  :nth-of-type(even) {
    border-left: 0;
    border-top: 0;
  }
  :nth-of-type(odd) {
    border-top: 0;
  }
  :nth-of-type(-n + 2) {
    border-top: 1px solid rgb(216, 218, 218);
  }

  .device_selection_span {
    max-width: 55%;
    position: absolute;
    top: 20px;
    left: 20px;
  }

  img {
    max-height: 185px;
    max-width: 120px;
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: -9;
    
    ${media.smalldesktop`
      max-width: 95px;
    `}

    ${media.tablet`
      max-width: 95px;
    `}

    ${media.mobile`
      max-width: 95px;
    `} 

    @media only screen and (min-device-width: 320px) and 
      (max-device-width: 480px) and 
      (-webkit-device-pixel-ratio: 2) and 
      (device-aspect-ratio: 2/3) {
      max-width: 80px;
    }
  }

  [type=radio] {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  [type=radio] + label {
    height: 100%;
    width: 100%;
    cursor: pointer;
  }

  [type=radio]:focus + label {
    outline: 1px dashed #000;
    z-index: 2;
  }

  ${media.smalldesktop`
    max-width: 320px;
  `}

  ${media.tablet`
    max-width: 320px;
  `} 
  
  ${media.tablet`
    ${commonBorderStyle}
  `}
  ${media.mobile`
    ${commonBorderStyle}
  `};
`;

const DeviceListContainer = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex-flow: row wrap;
  margin: 15px 0 35px 0;
  max-width: 770px;
`;

const Div = styled.div`
  max-width: 595px;
  p {
    padding: 10px 0;
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-size: 16px;
   font-style: normal;
   font-weight: 400;
   line-height: 20px; 
   letter-spacing: 0.5px;
  }

  ${media.mobile`
  p {
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
    letter-spacing: 0.5px;
  }
  `}

`;

const Span = styled.span`
font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
font-size: 20px;
font-style: normal;
font-weight: 400;
line-height: 24px;

  ${media.mobile`
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;  
  `};
`;


const MobileNumber = styled.div`
 font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
 font-size: 16px;
 font-style: normal;
 font-weight: 400;
 line-height: 20px;
 letter-spacing: 0.5px;
 color:#6F7171

  ${media.mobile`
  font-family: 'Verizon-NHG-eTX', Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-style: normal;
 font-weight: 400;
 line-height: 16px; 
  `};
`;

const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 64px 20px ;
  ${media.mobile`
    margin: 0;
    padding: 32px 16px ;
  `}
`;

const Header = styled(CommonHeader)`
  max-width: 598px;
  font-size: 48px;
  line-height: 48px;
  margin-bottom: 6px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-weight: 300;

${media.mobile`
  font-size: 32px;	
  line-height: 36px;
  font-weight: 300;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
`}
`;




